import React from "react";
import { Toolbar, Typography } from "@mui/material";
import { AppBarButton } from "./Footer.styles";
import { footerLinks } from "./footerConfig";
import { useTranslation } from "react-i18next";

/**
 * ToolbarUI
 * UI layout inside the footer bar.
 * - Left side: Brand name with current year
 * - Right side: Footer links (FAQ, Support, Feedback, Terms)
 */
const ToolbarUI = () => {
  const { t } = useTranslation("layout");
  return (
    <Toolbar>
      {/* Brand name (left aligned) */}
      <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
        {t("mithrilDefense")} {new Date().getFullYear()}
      </Typography>

      {/* Footer links (right aligned) */}
      {footerLinks.map(({ label, onClick }) => (
        <AppBarButton
          key={label}
          variant="text"
          color="inherit"
          onClick={onClick}
        >
          {label}
        </AppBarButton>
      ))}
    </Toolbar>
  );
};

export default ToolbarUI;
